// removed by extract-text-webpack-plugin
module.exports = {"container":"_3f6SC","text":"z5Z5e","facebook-container":"_2jDzj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItemShare/RichUpdatesItemShare.scss
// module id = ./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItemShare/RichUpdatesItemShare.scss
// module chunks = 4